// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyModerationMode-module__container--VpX4O{display:flex;flex-direction:column;align-items:center;padding:40px 0}.EmptyModerationMode-module__container--VpX4O .EmptyModerationMode-module__title--GWz0W{padding-top:15px;color:#070707;font-size:13px;font-weight:600;line-height:18px}.EmptyModerationMode-module__container--VpX4O .EmptyModerationMode-module__sub-title--dnE1h{padding-bottom:15px;color:rgba(7,7,7,.65);font-size:11px;font-weight:400;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EmptyModerationMode-module__container--VpX4O`,
	"title": `EmptyModerationMode-module__title--GWz0W`,
	"sub-title": `EmptyModerationMode-module__sub-title--dnE1h`,
	"subTitle": `EmptyModerationMode-module__sub-title--dnE1h`
};
export default ___CSS_LOADER_EXPORT___;
